import React, { useState } from "react";
import EditIcon from '@material-ui/icons/Edit';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import RegularButton from "components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import { blue, green, red } from "@material-ui/core/colors";
import {
  getInventory,
  reopenCPV,
  closeDeleteInventory,
  getInventoryExistence,
  reopenInventoryAction,
} from "redux/actions/inventories/inventoriesAction";
import CancelIcon from '@material-ui/icons/Cancel';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CachedIcon from "@material-ui/icons/Cached";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import { ModalV2 } from "components/Modal/ModalV2";
import ApiIcon from '@mui/icons-material/Api';
import { PERMISSIONS } from "router/permissions";
import { useToggle } from "hooks/useToggle";
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import { formatNumber } from "helpers/getNumberFormats";

export const columns = [
  {
    Header: "Fecha",
    accessor: 'date',
    filterable: true,
    filterMethod: (filter, row) => row.date.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Inv. Inicial",
    accessor: 'initialInventory',
    Cell: ({ value }) => isNaN(parseFloat(value)) ? "0.00" : formatNumber(value),
  },
  {
    Header: "Compras",
    accessor: 'shipments',
    Cell: ({ value }) => isNaN(parseFloat(value)) ? "0.00" : formatNumber(value),
  },

  {
    Header: "Ventas",
    Cell: ({ original }) => (
      <div>{original.cpv > 0 ? (formatNumber(original.sales + original.cpv)) : formatNumber(original.sales)}</div>
    )
  },
  {
    Header: "Gas Empleado",
    accessor: 'employeeGas',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Devol.",
    accessor: 'returns',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Uso Propio",
    accessor: 'carburations',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Carburación 2",
    accessor: 'carburations2',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Otras Entradas",
    accessor: 'otherEntries',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Otras Salidas",
    accessor: 'otherDepartures',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Trasp. Entrada",
    accessor: 'transfersEntry',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Trasp. Salida",
    accessor: 'transfersOutgoing',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Exist. Física",
    accessor: 'physicalExistance',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Inv. Final",
    accessor: 'finalInventory',
    Cell: ({ value }) => formatNumber(value),
  },
  {
    Header: "Dif.",
    accessor: 'difference',
    Cell: ({ value }) => formatNumber(value),
  },

  {
    Header: "Acciones",
    Cell: ({ original }) => {
      const { id, status } = original;
      const hist = useHistory();
      const {
        INVENTORIES_CONTROL_VIEW,
        INVENTORIES_CONTROL_EDIT,
        INVENTORIES_CONTROL_RECALCULATE,
        INVENTORIES_CLOSE,
        INVENTORIES_CONTROL_DELETE,
        INVENTORIES_CPV,
        INVENTORY_REOPEN,
        INVENTORIES_CPV_REOPEN,
      } = PERMISSIONS
      const dispatch = useDispatch();
      const { rules } = useSelector(({ login }) => login);
      const { tanks } = useSelector(({ tanks }) => tanks);
      const { units } = useSelector(({ unitsReducer }) => unitsReducer);
      const { station } = useSelector(({ inventories }) => inventories);

      const isView = rules.includes(INVENTORIES_CONTROL_VIEW)
      const isRecalculate = rules.includes(INVENTORIES_CONTROL_RECALCULATE)
      const isClose = rules.includes(INVENTORIES_CLOSE)
      const isDelete = rules.includes(INVENTORIES_CONTROL_DELETE)
      const isCpv = rules.includes(INVENTORIES_CPV)
      const isReopen = rules.includes(INVENTORY_REOPEN)
      const isReopenCpv = rules.includes(INVENTORIES_CPV_REOPEN)

      const { isLoadingComp } = useSelector(({ search }) => search);
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [modalAction, setModalAction] = useState(null);
      const [openInventory, setOpenInventory] = useToggle()

      const handleNav = () => {
        hist.push(`/admin/inventario-detalles/${id}`);
      };

      const closeInventory = () => {
        dispatch(closeDeleteInventory(id));
      };

      const deleteInventory = (del = true) => {
        dispatch(closeDeleteInventory(id, del));
      };

      const handleModalClose = () => {
        if (modalAction === 'close') {
          deleteInventory(false);
        } else if (modalAction === 'delete') {
          closeInventory();
        }
        setIsModalOpen(false);
      };

      const handleGetStation = () => {
        const tanksData = { tanks, units };
        dispatch(getInventory({
          inventoryId: id,
          navigation: handleNav,
          stationId: station?.id
        }));
      };

      const getExistence = (isCpv = false) => {
        dispatch(getInventoryExistence(id, isCpv));
      };

      const handleReopenCPV = () => {
        dispatch(reopenCPV(id))
      }

      const openModal = (action) => {
        setModalAction(action);
        setIsModalOpen(true);
      };

      const handleReopen = () => {
        dispatch(reopenInventoryAction(id, setOpenInventory));
      };

      return (
        <>
          {
            isView &&
            <RegularButton color="transparent" size="sm" round justIcon onClick={handleGetStation} disabled={isLoadingComp?.loadingInventory || isLoadingComp?.inventoryConf} tooltip={
              status !== "CLOSED"
                ? `Editar ${original?.isNew ? "Nuevo" : ""} Inventario`
                : "Ver Inventario"
            }>
              {
                status !== "CLOSED"
                  ? <EditIcon style={{ color: original?.isNew ? green[500] : blue[500] }} />
                  : <VisibilityIcon style={{ color: blue[800] }} />
              }
            </RegularButton>
          }
          {
            status !== "CLOSED" && isRecalculate &&
            <RegularButton
              round
              justIcon
              color="transparent"
              onClick={() => getExistence()}
              tooltip="Recalcular"
              size="sm"
              disabled={isLoadingComp?.loadingInventoryExistence}
            >
              <CachedIcon style={{ color: red[200] }} />
            </RegularButton>
          }
          {
            status !== "CLOSED" &&
            <>

              {
                isDelete &&
                <RegularButton color="transparent" size="sm" round justIcon onClick={() => openModal('delete')} tooltip="Eliminar">
                  <CancelIcon style={{ color: red[500] }} />
                </RegularButton>
              }
              {
                isClose &&
                <RegularButton
                  round
                  justIcon
                  color="transparent"
                  onClick={() => openModal('close')}
                  tooltip="Cerrar Inventario"
                  size="sm"
                >
                  <AssignmentTurnedInIcon style={{ color: green[500] }} />
                </RegularButton>
              }
            </>
          }
          {
            isCpv && original?.isCpv ?
              <>
                {original?.cpv === null ?
                  <RegularButton color="transparent" size="sm" round justIcon tooltip="CPV" onClick={() => getExistence(true)}
                    loading={isLoadingComp?.loadingInventoryExistence}
                  >
                    <ApiIcon style={{ color: blue[800] }} />
                  </RegularButton> : isReopenCpv ?
                    <RegularButton color="transparent" size="sm" round justIcon tooltip="Revertir CPV" onClick={() => handleReopenCPV()}
                      loading={isLoadingComp?.loadingInventoryExistence}
                    >
                      <ApiIcon style={{ color: red[200] }} />
                    </RegularButton> : null
                }
              </> : null
          }
          {
            status === "CLOSED" && isReopen &&
            <RegularButton
              round
              justIcon
              color="transparent"
              onClick={setOpenInventory}
              tooltip="Reabrir Inventario"
              loading={isLoadingComp?.loadingReopenInventory}

            >
              <ImportContactsIcon style={{ color: blue[800] }} />
            </RegularButton>

          }
          <ModalV2
            title={modalAction === 'close' ? "¿Cerrar inventario?" : "¿Eliminar inventario?"}
            justConfirm
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            flex
          >
            <RegularButton
              color="transparent"
              onClick={() => setIsModalOpen(false)}
            >
              Cancelar
            </RegularButton>
            <RegularButton
              color="success"
              onClick={handleModalClose}
            >
              Confirmar
            </RegularButton>
          </ModalV2>
          <ModalV2
            title="¿Reabrir inventario?"
            open={openInventory}
            onClose={setOpenInventory}
            justConfirm
            onSubmit={handleReopen}
          />
        </>
      );
    }
  }
];
